import { popup } from './popups.js';
import { audio } from '../audio/engine.js';
import type { QualitySetting } from '../render/quality.js';
import { lookName, setLookName, type LookName } from '../render/look.js';

const KEY = 'hollowmere-quality', FPS_KEY = 'hollowmere-fps';
const $ = <T extends HTMLElement = HTMLElement>(s: string) => document.querySelector(s) as T;

/** The settings popover: graphics quality and the three volume sliders. */
export class Settings {
  static quality(): QualitySetting {
    try { const q = localStorage.getItem(KEY); if (q === 'low' || q === 'medium' || q === 'high' || q === 'auto') return q; } catch { /* ignore */ }
    return 'auto';
  }
  private frames = 0; private acc = 0;
  /** Frames per second to draw at most (0: as fast as the screen refreshes). */
  fpsCap = 60;

  constructor(onQuality: (q: QualitySetting) => void) {
    const panel = $('#settings'), btn = $('#btn-settings');
    btn.addEventListener('click', () => { audio.unlock(); panel.hidden = !panel.hidden; btn.setAttribute('aria-expanded', String(!panel.hidden)); });
    const shut = () => { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); };
    $('#settings-close').addEventListener('click', shut);
    $('#settings-x').addEventListener('click', shut);
    popup(panel, $('#settings-head'), 'settings', { close: shut, openers: [btn] });
    const seg = $('#q-seg');
    const paint = (q: QualitySetting) => seg.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.q === q)));
    paint(Settings.quality());
    seg.querySelectorAll<HTMLButtonElement>('button').forEach(b => b.addEventListener('click', () => {
      const q = b.dataset.q as QualitySetting;
      try { localStorage.setItem(KEY, q); } catch { /* ignore */ }
      paint(q); onQuality(q);
    }));
    const lseg = $('#look-seg');
    lseg?.querySelectorAll<HTMLButtonElement>('button').forEach(b => {
      b.setAttribute('aria-pressed', String(b.dataset.look === lookName()));
      b.addEventListener('click', () => { const n = b.dataset.look as LookName; if (n === lookName()) return; setLookName(n); location.reload(); });
    });
    try { const v = Number(localStorage.getItem(FPS_KEY)); if (v === 0 || v === 30 || v === 60) this.fpsCap = localStorage.getItem(FPS_KEY) === null ? 60 : v; } catch { /* ignore */ }
    const fseg = $('#fps-seg');
    const paintFps = () => fseg.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.fps) === this.fpsCap)));
    paintFps();
    fseg.querySelectorAll<HTMLButtonElement>('button').forEach(b => b.addEventListener('click', () => {
      this.fpsCap = Number(b.dataset.fps);
      try { localStorage.setItem(FPS_KEY, String(this.fpsCap)); } catch { /* ignore */ }
      paintFps();
    }));
    for (const k of ['music', 'ambient', 'sfx'] as const) {
      const input = $<HTMLInputElement>(`#vol-${k}`);
      input.value = String(Math.round(audio.settings[k] * 100));
      input.addEventListener('input', () => { audio.unlock(); audio.settings[k] = Number(input.value) / 100; audio.apply(); });
    }
    const mute = $<HTMLButtonElement>('#btn-mute');
    const paintMute = () => { mute.setAttribute('aria-pressed', String(audio.settings.muted)); mute.textContent = audio.settings.muted ? 'Sound off' : 'Sound on'; btn.classList.toggle('muted-ind', audio.settings.muted); };
    paintMute();
    mute.addEventListener('click', () => { audio.unlock(); audio.settings.muted = !audio.settings.muted; audio.apply(); paintMute(); });
  }

  frame(dt: number) {
    this.frames++; this.acc += dt;
    if (this.acc < 1) return;
    const el = document.getElementById('fps');
    if (el && !($('#settings').hidden)) el.textContent = `${Math.round(this.frames / this.acc)} fps`;
    this.frames = 0; this.acc = 0;
  }
}
